import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Error404 from "../views/Error404.vue";
import Login from "../views/Login.vue";
import Package from "../views/Package.vue";
import store from "../store";

import AuthLayout from "../components/layouts/Default";

Vue.use(VueRouter);

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated || !store.getters.tokenExp) {
    next();
    return;
  }
  next("/");
};

const ifAuthenticated = (to, from, next) => {
  console.log(store.getters.isAuthenticated);
  console.log(store.getters.tokenExp);
  if (store.getters.isAuthenticated && store.getters.tokenExp) {
    next();
    return;
  }
  next("/login");
};

const routes = [
  {
    path: "",
    component: AuthLayout,
    // child routes now have the style of Layout
    children: [
      {
        path: "/",
        name: "Home",
        component: Home,
        beforeEnter: ifAuthenticated
      },
      {
        path: "/about",
        name: "About",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/About.vue"),
        beforeEnter: ifAuthenticated
      },
      {
        path: "/error",
        name: "Error404",
        component: Error404
      },
      {
        path: "/package",
        name: "Package",
        component: Package,
        beforeEnter: ifAuthenticated
      },
      { path: "/", redirect: { name: "Package" }, beforeEnter: ifAuthenticated }
    ]
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    beforeEnter: ifNotAuthenticated
  },
  { path: "*", redirect: { name: "Error404" }, beforeEnter: ifAuthenticated }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
